export const GET_NOTES_DATA_REQUEST="GET_NOTES_DATA_REQUEST"
export const GET_NOTES_DATA_SUCCESSFUL="GET_NOTES_DATA_SUCCESSFUL"
export const GET_NOTES_DATA_FAILURE="GET_NOTES_DATA_FAILURE"


export const ADD_NOTES_DATA_REQUEST="ADD_NOTES_DATA_REQUEST"
export const ADD_NOTES_DATA_SUCCESSFUL="ADD_NOTES_DATA_SUCCESSFUL"
export const ADD_NOTES_DATA_FAILURE="ADD_NOTES_DATA_FAILURE"

export const UPDATE_NOTES_DATA_REQUEST="UPDATE_NOTES_DATA_REQUEST"
export const UPDATE_NOTES_DATA_SUCCESS="UPDATE_NOTES_DATA_SUCCESS"
export const UPDATE_NOTES_DATA_FAILURE="UPDATE_NOTES_DATA_FAILURE"

export const DELETE_NOTES_DATA_REQUEST="DELETE_NOTES_DATA_REQUEST"
export const DELETE_NOTES_DATA_SUCCESS="DELETE_NOTES_DATA_SUCCESS"
export const DELETE_NOTES_DATA_FAILURE="DELETE_NOTES_DATA_FAILURE"





